import { useEffect } from "react";

const APP_NAME = "Sked Link";

/**
 * Sets document.title for the lifetime of the component.
 * Replaces react-helmet usage in the legacy app.
 */
export function useDocumentTitle(title?: string | null): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · ${APP_NAME}` : APP_NAME;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
